import styled from 'styled-components';

export const StyledDashboard = styled.div`
  /* padding: 56px 20px; */
`;
